import globalErrorHandler from "./globalErrorHandler";
import {User, UserFormData} from "../types/user";
import {DriverFormData, IDriver} from "../types/Driver";
import {axiosClient} from "./axios";
import {ApiResponse} from "./ApiResponse";

export const getUsers = (page?: number, filters?: string[]) => new Promise<ApiResponse<User[]>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/users?page=' + page)
        .then(value => resolve(value.data as ApiResponse<User[]>))
        .catch(err => globalErrorHandler(err, reject))
})

export const getUser = (id?: string) => new Promise<ApiResponse<User>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/users/' + id).then(value => resolve(value.data as ApiResponse<User>))
        .catch(err => globalErrorHandler(err, reject))
})

export const getDrivers = (page?: number, filters?: string[]) => new Promise<ApiResponse<DriverFormData[]>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/drivers?page=' + page).then(value => resolve(value.data as ApiResponse<DriverFormData[]>))
        .catch(err => globalErrorHandler(err, reject))
})

export const getDriver = (driverId: string) => new Promise<ApiResponse<DriverFormData>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/drivers/' + driverId).then(value => resolve(value.data as ApiResponse<DriverFormData>))
        .catch(err => globalErrorHandler(err, reject))
})

export const updateDriverStatus = (driverId: string, status: DriverFormData['status']) => new Promise<ApiResponse<DriverFormData>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.post('/drivers/updateStatus', {
        driverId,
        status
    }).then(value => resolve(value.data as ApiResponse<DriverFormData>))
        .catch(err => globalErrorHandler(err, reject))
})

export const getNonDrivers = () => new Promise<ApiResponse<User[]>>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.get('/users?isDriver=false').then(value => resolve(value.data as ApiResponse<DriverFormData[]>))
        .catch(err => globalErrorHandler(err, reject))
})

export const createDriverProfile = (driverData: DriverFormData,) => new Promise<User[]>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.post('/drivers', driverData).then(value => resolve(value.data['result'] as User[]))
        .catch(err => globalErrorHandler(err, reject))
})

export const createUser = (body: UserFormData | User,) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.post('/users', body).then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})

export const updateUser = (id: string, body: UserFormData) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.put('/users/' + id, body)
        .then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})

export const updateProfile = (body: UserFormData) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.post('/updateAccount', body)
        .then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})

export const deleteUser = (id: string) => new Promise<void>(async (resolve, reject) => {
    const axios = await axiosClient()
    axios.delete('/users/' + id)
        .then(() => resolve())
        .catch(err => globalErrorHandler(err, reject))
})

